module.exports = __webpack_public_path__ + "img/motorbikeRearLeftOutline.257277d9.svg";